/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { ReactNode } from 'react';

import { useMediaQuery, useTheme } from '@material-ui/core';
import NavigateBackStep from 'ui/navigateBackStep/NavigateBackStep';
import Button from 'ui/Button/Button';

import styles from './BulksWrapper.module.scss';

import remove from 'assets/icons/delete_icon.svg';

interface IBulksWrapper {
  onClickBack: () => void;
  onDeleteBen: () => void;
  children: ReactNode;
}

const BulksWrapper = ({ onClickBack, onDeleteBen, children }: IBulksWrapper) => {
  const downMdScreen = useMediaQuery(useTheme().breakpoints.down('sm'));

  return (
    <div className={styles.container}>
      {!downMdScreen && <NavigateBackStep onClick={onClickBack} className={styles.backBtn}>Back</NavigateBackStep>}

      <div className={styles.headerWrapper}>
        <h2 className={styles.bulkHeader}>Beneficiary List</h2>
        <button type="button" onClick={onDeleteBen} className={styles.deleteBeneficiaryBtn}>
          <img src={remove} alt="delete icon" width="12" height="12" />
          Delete All Beneficiaries
        </button>
      </div>

      <div>{children}</div>
    </div>
  );
};

export default BulksWrapper;
